import { keyframes } from 'styled-components';

const Shimmer = keyframes`
  0% {
    background-position: -1000px 0;
  }
  100% {
    background-position: 1000px 0;
  }
`;

export default {
  Shimmer,
};
